import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import CalculoCustoMotStore from "../stores/CalculoCustoMotStore";
import { CalculoCustoMotFiltro } from "../components/CalculoCustoMotFiltro";
import { formatarReal } from "../../../utils/formatar";
import { LoadingBlockFields } from "../../comum/components/LoadingBlockFields";
import { Col, Row, FormGroup, Label, Input } from "reactstrap";
import { formatRespostaCalculoCustoMot } from "../../../utils/functions";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

const COLUNASVALIDACAO =[
    { key: "1", label: "Tipo", dataField: "tipo", width: "15", isKey: true, dataFormat: formatRespostaCalculoCustoMot},
    { key: "2", label: "Mensagem", dataField: "mensagem", width: "200" } ]

@inject("store")
@DataWrapper
@observer
export class CalculoCustoMot extends Component {
//RHFPP-1548 - Consulta Custo Mot
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.modalStore = this.props.store.modalStore;
        this.loginStore = this.props.store.loginStore;
        /* Selecionar Controller */
        this.controller = new CalculoCustoMotStore();

    }

    componentDidMount() {
        //this.controller.carregarDados();
        this.tituloPaginaStore.setTitulo("Cálculo de custo para contratação de MOT");

        this.controller.carregarTabela();

        /*         this.tituloPaginaStore.setBotoesMobile([
                    {
                        label: "Ordenar",
                        icone: "sort",
                        acao: () => this.modalStore.toggleModal('ordenar')
                    }, {
                        label: "Filtrar",
                        icone: "search",
                        acao: () => this.modalStore.toggleModal('filtrar')
                    }
                ]); */
    }

    /*     obterTituloMobile = (objeto) => { //TODO: rever
            return "Lotes " + objeto.id;
        }; */

    /*     obterConteudoMobile = (objeto) => { //TODO: rever
            return (
                <div>
                    {"Unidade de negócio (BU): " + nullable(objeto.nomeEmpresaGlobo)}<br />
                    {"Qtde MOTs: " + nullable(objeto.quantidadeMOTs)}<br />
                    {"Valor total: " + nullable(formatarValorReal(objeto.valorTotal))}<br />
                    {"Data geração: " + nullable(formatarDataISO8601(objeto.dataGeracao))}<br />
                    {"Nota fiscal: " + nullable(objeto.numeroNotasFiscais)}<br />
                    {"Data de emissão da nota fiscal: " + nullable(objeto.dataEmissaoNotasFiscais)}<br />
                    {"Status: " + nullable(objeto.status)}<br />
                    {this.loginStore.isPerfilAdministradorLogado &&
                        <div>
                            {"ETT: " + nullable(objeto.nomeEtt)}<br />
                            {"Data integração: " + nullable(objeto.dataHoraEnvioEBS)}<br />
                            {"Erro integração: " + nullable(objeto.erroIntegracaoEBS)}<br />
                            {"Número RC: " + nullable(objeto.numeroRc)}<br />
                            {"Número OC: " + nullable(objeto.numeroOc)}
                        </div>
                    }
                </div>
            )
        }; */


    render() {

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        {this.appStore.width > 768}
                        <LoadingBlockFields carregando={this.controller.carregando}>
                            <CalculoCustoMotFiltro
                                onSubmit={(filtro) => this.controller.calcular(filtro)}
                                controller={this.controller}
                                history={this.props.history}
                                location={this.props.location}
                            />
                            <div>
                                {this.controller.dadosCalculo && <h4>Detalhes do cargo</h4>}
                                {this.controller.dadosCalculo && <Row>
                                    <Col xs={12} md={6} lg={6}>
                                        <FormGroup>
                                            <Label>Cargo</Label>
                                            <Input type="text" value={this.controller.getNomeCargo()} readOnly />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Competência</Label>
                                            <Input type="text" value={this.controller.getCompetenciaCargo()} readOnly />
                                        </FormGroup>
                                    </Col>
                                </Row>}
                                {this.controller.dadosCalculo && <Row>
                                    <Col xs={12} md={6} lg={3}>
                                        <FormGroup>
                                            <Label>{this.controller.getTituloSalarioBase()}</Label>
                                            <Input type="text"
                                                value={formatarReal(this.controller.getSalario())}
                                                readOnly/>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={3}>
                                        <FormGroup>
                                            <Label>Sindicato</Label>
                                            <Input type="text" value={this.controller.getSindicato()} readOnly />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={6} md={4} lg={2}>
                                        <FormGroup>
                                            <Label>Jornada mensal (h)</Label>
                                            <Input value={this.controller.getJornadaMensal()} readOnly />
                                        </FormGroup>
                                    </Col>
                                    {/*
                                    <Col xs={6} md={6} lg={6}>
                                        <FormGroup>
                                            <Label>Validação do valor proposto</Label>
                                            <Input value={this.controller.getMsgValidacao()} readOnly />
                                        </FormGroup>
                                    </Col>
                                    */}
                                </Row>}
                                {this.controller.dadosCalculo && <h4>Resposta do cálculo</h4>}
                                {/*
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <FormGroup>
                                            <Input type="textarea" value={this.controller.getResultado()} readOnly />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                 */}
                                {this.controller.dadosCalculo && <Row>
                                <BootstrapTable ref='table' version='4' data={this.controller.respostaCalculo} striped hover condensed TableHeaderColumn tableBodyClass="table-custom-mot">
                                    {
                                        COLUNASVALIDACAO.map(column =>
                                            <TableHeaderColumn columnTitle {...column} >
                                                {column.label}
                                            </TableHeaderColumn>
                                        )
                                    }
                                </BootstrapTable>
                                </Row>}
                            </div>
                        </LoadingBlockFields>
                    </div>
                </div>
            </div>
        );
    }
}